/**
 * Проверка корректнсти значения для цен
 * @param value - значение
 */
export const checkCorrectValuePrice = (value: string | null) => {
  return value !== null && parseFloat(value.trim()) > 0
}
